import {AbstractControl, ValidationErrors} from '@angular/forms';

export const usernameValidators = function (control: AbstractControl): ValidationErrors | null  {
const value: string = control.value || '';
if (!value) { return null; }
if (value === 'NONE') {
  return {pattern: 'Invalid format'};
}
};
